function cleanText(value, max = null) {
  const text = String(value || '').replace(/\s+/g, ' ').trim();
  if (!text) return '';
  if (!Number.isFinite(max) || text.length <= max) return text;
  return `${text.slice(0, Math.max(max - 3, 0)).trimEnd()}...`;
}

function normalizedState(item) {
  return String(item?.publicReliabilityState || '').toUpperCase();
}

function normalizedPreciseStatus(item) {
  return String(item?.preciseExpressionStatus || '').toUpperCase();
}

function normalizedTradeStatus(item) {
  return String(item?.tradeStatusLabel || item?.actionLabel || '').toUpperCase();
}

export function buildPublicExpressionDisclosure(item, fallbackExpression = '') {
  const state = normalizedState(item);
  const preciseStatus = normalizedPreciseStatus(item);
  const tradeStatus = normalizedTradeStatus(item);
  const fallback = cleanText(fallbackExpression, 260);
  const publicLine = cleanText(item?.publicExpressionLine, 260);
  const reliabilitySummary = cleanText(item?.publicReliabilitySummary, 220);
  const bestExpressionSummary = cleanText(item?.bestExpressionSummary, 260);
  const preciseExpressionSummary = cleanText(item?.preciseExpressionSummary, 220);

  if (tradeStatus === 'PREPARE') {
    const watchHeadline = state === 'INTERNAL_ONLY'
      ? 'No public trade is ready yet. Keep this on a watchlist into the next catalyst.'
      : 'Watchlist posture only until the catalyst or market proof improves.';
    return {
      label: 'Watchlist',
      headline: watchHeadline,
      support: reliabilitySummary || 'The thesis may be live, but a prepare-rated idea should be monitored into the next proof point rather than treated like a fully active public trade.',
      internalLine: (preciseStatus === 'PARTIAL' || preciseStatus === 'READY') && preciseExpressionSummary
        ? `${preciseStatus === 'READY' ? 'Cleaner basket on file' : 'Cleaner internal basket'}: ${preciseExpressionSummary}`
        : (bestExpressionSummary ? `Current basket on file: ${bestExpressionSummary}` : null),
    };
  }

  if (state === 'INTERNAL_ONLY') {
    return {
      label: 'Public basket',
      headline: 'No tradeable public basket is ready yet.',
      support: reliabilitySummary || 'The thesis may be real, but the public wrapper is still blocked or missing.',
      internalLine: preciseExpressionSummary ? `Cleaner stock basket: ${preciseExpressionSummary}` : null,
    };
  }

  if (state === 'PUBLIC_WITH_PROXY_WARNING') {
    const readyPrecise = preciseStatus === 'READY';
    return {
      label: 'Public proxy',
      headline: fallback || publicLine || 'Interim public proxy only.',
      support: reliabilitySummary || (readyPrecise
        ? 'The live public wrapper is still broad, but a cleaner stock basket is now available behind it.'
        : 'The live basket is usable, but it is still only a broad or imperfect public proxy.'),
      internalLine: (preciseStatus === 'PARTIAL' || preciseStatus === 'READY') && preciseExpressionSummary
        ? `${readyPrecise ? 'Cleaner stock basket' : 'Cleaner internal basket'}: ${preciseExpressionSummary}`
        : null,
    };
  }

  return {
    label: 'Basket',
    headline: fallback || publicLine || bestExpressionSummary || 'Basket still being normalized.',
    support: null,
    internalLine: null,
  };
}
